<template>
	<inertia-head title="BCC Expired" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{$page.props.app.name}} - Blockchain Circle (BCC)
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Blockchain Circle Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div v-if="flash" class="alert alert-dismissible shadow" 
		:class="flash.title=='Status Success' ? 'alert-success' : 'alert-danger'" 
		role="alert"
	>
		<h3 class="alert-heading fs-5 fw-bold mb-4">
			{{flash.title}}
		</h3>
		<p class="mb-0">
			{{flash.message}}
		</p>
	</div>

	<div v-if="form.errors.subscription" class="alert alert-danger" role="alert">
		<h3 class="alert-heading fs-5 fw-bold mb-1">Please choose subscription</h3>
		<p class="mb-0">{{ form.errors.subscription }}</p>
	</div>

	<div class="content">
		<div class="alert alert-danger alert-dismissible shadow" role="alert">
			<h3 class="alert-heading fs-5 fw-bold mb-4">
				Subscription Expired
			</h3>
			<p class="mb-0">
				You subscription to
				<span class="fw-semibold">Blockchain Circle</span> has expired last <span class="fw-semibold">{{$page.props.user.bcc_expiry_format}}</span>.
			</p>
		</div>

		<div class="content mt-5">
			<div class="row">
				<div class="col-xl-5 col-lg-5">
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Subscription</h3>
						</div>
						<div class="block-content block-content-full">
							<div class="row">
								<div
									class="col-12"
									v-for="product in products"
									:key="product.prod_id"
								>
									<div class="form-check form-block mb-3">
										<input
											v-model="form.subscription"
											class="form-check-input"
											type="radio"
											:value="product.prod_id"
											:id="product.prod_id"
											name="subscription"
										/>
										<label class="form-check-label" :for="product.prod_id">
											<span class="d-flex align-items-center">
												<h6 class="fs-sm mb-0">
													{{ product.membership_type }}
												</h6>
												<span
													v-if="product.add_display"
													class="badge bg-warning ms-1"
												>
													{{ product.add_display }}
												</span>
											</span>
											<small>&#8369;{{ product.amount }}</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Payment method</h3>
						</div>
						<div class="block-content block-content-full">
							<form @submit.prevent="renewBCC">
								<div class="row">
									<div class="col-12">
										<div class="row">
											<div class="col-6">
												<div class="form-check form-block mb-4">
													<input
														v-model="form.mop"
														class="form-check-input"
														type="radio"
														:value="'CARD'"
														id="card"
														name="payment_method"
													/>
													<label class="form-check-label" for="card">
														<span
															class="d-flex align-items-center"
															style="
																background-image: url(/media/logo/stripe-logo.png);
																background-size: contain;
																background-repeat: no-repeat;
																background-position: center;
																height: 80px;
															"
														>
														</span>
													</label>
												</div>
											</div>
											<div class="col-6">
												<div class="form-check form-block mb-4">
													<input
														v-model="form.mop"
														class="form-check-input"
														type="radio"
														:value="'DRAGONPAY'"
														id="dragonpay"
														name="payment_method"
													/>
													<label class="form-check-label" for="dragonpay">
														<span
															class="d-flex align-items-center"
															style="
																background-image: url(/media/logo/dragonpay-logo.png);
																background-size: contain;
																background-repeat: no-repeat;
																background-position: center;
																height: 80px;
															"
														>
														</span>
													</label>
												</div>
											</div>
											<!-- <div class="col-4">
												<div class="form-check form-block mb-4">
													<input
														v-model="form.mop"
														class="form-check-input"
														type="radio"
														:value="'BROPAY'"
														id="bropay"
														name="payment_method"
													/>
													<label class="form-check-label" for="bropay">
														<span
															class="d-flex align-items-center"
															style="
																background-image: url(/media/logo/bropay-logo.png);
																background-size: contain;
																background-repeat: no-repeat;
																background-position: center;
																height: 80px;
															"
														>
														</span>
													</label>
												</div>
											</div> -->
										</div>
									</div>
								</div>
								<div v-if="form.mop == 'CARD'">
									<div v-if="has_card" class="form-check form-switch mb-4">
										<input
											v-model="form.use_existing_card"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="example-switch-default1"
											name="example-switch-default1"
										/>
										<label class="form-check-label" for="example-switch-default1">
											Use existing card
										</label>
									</div>
									<div v-if="has_card && form.use_existing_card" class="mb-4">
										<p class="mb-0">
											<span class="fw-semibold">CARD:</span>
											<i>**** **** **** {{ card.card_last4 }}</i>
											<span class="badge bg-primary ms-2">{{ card.brand }}</span>
										</p>
									</div>
									<div v-else class="form-group mb-4">
										<stripe @accept-token="acceptToken" ref="stripe" />
										<div v-if="form.errors.card" class="invalid-feedback d-block">
											<i class="fa fa-exclamation-circle"></i>
											{{ form.errors.card }}
										</div>
									</div>
								</div>
								<button
									type="submit"
									class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
									:disabled="
										form.processing || !form.isDirty || (form.mop === 'CARD' && !form.token && !form.use_existing_card)
									"
								>
									<span v-if="!form.processing">Subscribe</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import AuthLayout from '../../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../../Shared/Components/Stripe'
import { onMounted, watch } from 'vue'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default { 
	layout: AuthLayout, 
	props: {
		test 		: String,
		products 	: Object,
		has_card 	: Boolean,
		card 		: Object,
		flash 		: Object
	},
	components:{
		Stripe
	},
	mounted(){
		const pageContainer = document.getElementById('page-container');
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
	},
	setup(props){

		const form = useForm({
					subscription: null,
					mop: 'CARD',
					token: null,
					use_existing_card: props.has_card ? true : false,
					test: props.test,
				})


		const acceptToken = (token) => {
								form.token = token
							}

		const renewBCC = () => {
						form.post(route('member.bcc.post.renew'), {
							preserveState: true,
							preserveScroll: true,
						})
					}

		watch(
			() => form.mop,
			(mop) => {
				
				if(mop=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(mop!='CARD')
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		return{
			form,
			acceptToken,
			renewBCC
		}

	} 
}

</script>
